import createLogicalCompositorWith from './createLogicalCompositorWith';

const orify = createLogicalCompositorWith('some');

export default orify;
